export function getSnowDate(){
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    // switch in July, months are numbered from 0 so July is 6.
    if(month >= 6){
        return year;
    } else {
        return year - 1;
    }
}
